import LoginIcon from "@mui/icons-material/Login";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import PostAddIcon from "@mui/icons-material/PostAdd";
import LogoutIcon from "@mui/icons-material/Logout";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LocationPinIcon from "@mui/icons-material/LocationPin";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import CropIcon from "@mui/icons-material/Crop";
import HouseIcon from "@mui/icons-material/House";
import SearchIcon from "@mui/icons-material/Search";
import StarIcon from "@mui/icons-material/Star";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import PhoneIcon from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const icons = {
  LoginIcon,
  PersonAddAltIcon,
  PostAddIcon,
  LogoutIcon,
  NavigateNextIcon,
  LocationPinIcon,
  LocalAtmIcon,
  CropIcon,
  HouseIcon,
  SearchIcon,
  StarIcon,
  FavoriteBorderIcon,
  FavoriteIcon,
  ArrowForwardIcon,
  ArrowBackIcon,
  AddCircleIcon,
  EditNoteIcon,
  AccountCircleIcon,
  CameraAltIcon,
  DeleteIcon,
  FiberManualRecordIcon,
  PhoneIcon,
  WhatsAppIcon,
};

export default icons;
